import * as Immutable from 'immutable';
import type * as React from 'react';
import DesignLabStore from './DesignLab/DesignLabStore';
import UIToastStore from './UIToastStore';
import AccountStore from './Account/AccountStore';

export interface IUIDataStore {
	toast: UIToastStore,
	loaders: Immutable.Map<string, boolean>,
	validData: Immutable.Map<string, boolean>,
	apiErrors: Immutable.Map<string, Record<string, unknown>>
	scrollBlockers: Immutable.List<React.ReactNode>,
	intervals: Immutable.Map<string, ReturnType<typeof setInterval>>
	designLab: DesignLabStore,
	account: AccountStore,
	createUrl: string,
	recentlyViewedProductIds: Immutable.List<string>,
}

export const UIDataStoreFactory = Immutable.Record<IUIDataStore>({
	toast: new UIToastStore(),
	loaders: Immutable.Map<string, boolean>(),
	validData: Immutable.Map<string, boolean>(),
	apiErrors: Immutable.Map<string, Record<string, unknown>>(),
	scrollBlockers: Immutable.List<React.ReactNode>(),
	intervals: Immutable.Map<string, ReturnType<typeof setInterval>>(),
	designLab: new DesignLabStore(),
	account: new AccountStore(),
	createUrl: '',
	recentlyViewedProductIds: Immutable.List<string>(),
});

export default class UIDataStore extends UIDataStoreFactory {}
